/** @jsxImportSource @emotion/react */
import {
  menuCSS,
  menuListCSS,
} from "@/app/components/form-fields/select/styling";
import { css } from "@emotion/react";
import * as React from "react";

export const Menu = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & {}
>(({ children, ...props }, ref) => {
  return (
    <div css={css(menuCSS())} ref={ref} {...props}>
      <div css={css(menuListCSS())}>{children}</div>
    </div>
  );
});
